module.exports = __webpack_public_path__ + "img/Anhänger_Spül.f390235e.svg";